<aside [class.collapsed]="isCollapsed" [ngClass]="{'dark-mode': isDarkMode}">
  <nav class="sidebar-container" aria-label="Main Navigation">
    <ul class="sidebar-sections">
      @for (section of sections; track section; let i = $index) {
        <li
          class="sidebar-section"
          [ngClass]="{'collapsed-section': isCollapsed}">
          <!-- Dropdown container for sections with children -->
          @if (section.children && section.children.length > 0) {
            <div class="dropdown-container">
              <div class="dropdown-header" (click)="toggleDropdown(i)">
                <div class="header-content">
                  <!-- Section with p-button and icon -->
                  <p-button
                    [label]="!isCollapsed ? section.label : undefined"
                    [icon]="section.icon"
                    styleClass="p-button-text p-button-lg w-full justify-content-start custom-icon-size"
                    [routerLink]="section.routerLink"
                  ></p-button>
                </div>
                <!-- Dropdown Toggle Icon (Hidden in collapsed mode) -->
                <div>
                  <img
                    [src]="collapsedSections[i] ? 'assets/images/chevron-down.svg' : 'assets/images/chevron-up.svg'"
                    alt="Toggle dropdown"
                    class="toggle-icon"
                    />
                  </div>
                </div>
                <!-- Dropdown list for children (controlled via CSS) -->
                @if (!collapsedSections[i]) {
                  <ul class="dropdown-list" [class.hover-visible]="isCollapsed"  [ngClass]="{'dark-mode': isDarkMode}" >
                    @for (child of section.children; track child) {
                      <li class="dropdown-item" [ngClass]="{'dark-mode': isDarkMode}">
                        <span class="item-label"  [routerLink]="child.routerLink">{{ child.label }}</span>
                      </li>
                    }
                  </ul>
                }
              </div>
            }
            <!-- Label for sections without children, applying same styles as dropdown-header -->
            @if (!section.children || section.children.length === 0) {
              <div class="dropdown-header">
                <div class="header-content">
                  <p-button [label]="!isCollapsed ? section.label : undefined"
                    [icon]="section.icon"
                    styleClass="p-button-text p-button-lg w-full justify-content-start custom-icon-size"
                    [badge]="i === 2 && !isCollapsed ? '4' : undefined"
                    [badgeClass]="i === 2 ? 'p-badge-danger' : ''"
                    [routerLink]="section.routerLink"
                  ></p-button>
                </div>
                <div></div> <!-- Empty space for alignment consistency -->
              </div>
            }
          </li>
        }
      </ul>

      <p-divider></p-divider>

      <!-- Utilities Section -->
      <ul class="sidebar-utilities">
        @for (utility of utilities; track utility) {
          <li class="utility-item">
            <div class="dropdown-header">
              <div class="header-content">
                <p-button [label]="!isCollapsed ? utility.label : undefined"
                  [icon]="utility.icon"
                  [routerLink]="utility.routerLink"
                  styleClass="p-button-text p-button-lg w-full justify-content-start custom-icon-size">
                </p-button>
              </div>
              <div></div> <!-- Empty space for alignment consistency -->
            </div>
          </li>
        }

        <li class="utility-item">
          <div class="dropdown-header">
            <div class="header-content">
              <p-button
                icon="pi pi-download"
                (click)="exportToExcel()"
                pTooltip="XLS"
                [label]="!isCollapsed ? 'Report' : undefined"
                title="Export"
                styleClass="p-button-text p-button-lg w-full justify-content-start custom-icon-size"
                tooltipPosition="bottom">
              </p-button>
            </div>
            <div></div> <!-- Empty space for alignment consistency -->
          </div>

        </li>
        <li>
          @if (isMobileView) {
            <div class="dropdown-header">
              <div class="header-content">
                <p-button [label]="!isCollapsed ? 'Dark Mode' : undefined"
                  [icon]="isDarkMode ? 'pi pi-sun' : 'pi pi-moon'"
                  styleClass="p-button-text p-button-lg w-full justify-content-start custom-icon-size">
                </p-button>
                <p-toggleSwitch (click)="toggleDarkMode()" class="p-toggleSwitch"></p-toggleSwitch>
              </div>
            </div>
          }

        </li>

        <li>
          @if (isMobileView) {
            <div class="dropdown-header">
              <div class="header-content">
                <p-button [label]="!isCollapsed ? 'Dark Mode' : undefined"
                  [icon]="isDarkMode ? 'pi pi-sun' : 'pi pi-moon'"
                  styleClass="p-button-text p-button-lg w-full justify-content-start custom-icon-size">
                </p-button>
                <p-toggleSwitch (click)="toggleDarkMode()" class="p-toggleSwitch"></p-toggleSwitch>
              </div>
            </div>
          }

        </li>




        <!-- Export to Excel -->
        <!-- (click)="exportExcel()" -->

      </ul>

    </nav>
  </aside>
